/**
 * @generated SignedSource<<308d8ea762a7fa250bd925d50e81cd4f>>
 * @relayHash 3b98665a502cac11f0f0e17a07349edb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fd2c3ff0e434e977560973adbde3b7cc5f31ab2753416516ff2b5dee879618fd

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceSubscriptionContentType = "BLOGPOST" | "COMMENT" | "DATABASE" | "EMBED" | "FOLDER" | "PAGE" | "WHITEBOARD" | "%future added value";
export type ContentTypesTitleSubscription$variables = {
  id: string;
};
export type ContentTypesTitleSubscription$data = {
  readonly confluence_onContentModified: {
    readonly __typename: "ConfluenceContentModified";
    readonly _deltas: ReadonlyArray<string> | null;
    readonly contentTitleUpdated: {
      readonly __typename: "ConfluenceContentTitleUpdated";
      readonly contentTitle: string | null;
    } | null;
    readonly id: string;
    readonly type: ConfluenceSubscriptionContentType;
  } | null;
};
export type ContentTypesTitleSubscription = {
  response: ContentTypesTitleSubscription$data;
  variables: ContentTypesTitleSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ConfluenceContentModified",
    "kind": "LinkedField",
    "name": "confluence_onContentModified",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "kind": "ScalarField",
        "name": "id"
      },
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "_deltas"
      },
      {
        "concreteType": "ConfluenceContentTitleUpdated",
        "kind": "LinkedField",
        "name": "contentTitleUpdated",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "contentTitle"
          },
          (v1/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentTypesTitleSubscription",
    "selections": (v2/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentTypesTitleSubscription",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3b98665a502cac11f0f0e17a07349edb",
    "id": "fd2c3ff0e434e977560973adbde3b7cc5f31ab2753416516ff2b5dee879618fd",
    "metadata": {},
    "name": "ContentTypesTitleSubscription",
    "operationKind": "subscription",
    "text": "subscription ContentTypesTitleSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,__typename,_deltas,contentTitleUpdated{contentTitle,__typename}}}"
  }
};
})();

(node as any).hash = "ec5cbfcceb83c8c688c2eb6a721f9544";

export default node;
